export enum CRUD {
    EDIT = "EDIT",
    CREATE = "CREATE",
    UPDATE = "UPDATE",
    DELETE = "DELETE",
    EDIT_BRANDLY = "EDIT_BRANDLY"
}